/**
 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v18.1.2
 * @link http://www.ag-grid.com/
 * @license MIT
 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var eventKeys_1 = require("./eventKeys");
exports.Events = eventKeys_1.Events;



//////////////////
// WEBPACK FOOTER
// ./~/ag-grid/dist/lib/events.js
// module id = ./node_modules/ag-grid/dist/lib/events.js
// module chunks = 5